// Precios — página propia para la salud de precios y el precio sugerido
// (15-sep-2026, pedido Maxi para Nicolás): lo mismo que el panel de /quotations,
// pero a un clic desde el menú y con la explicación de cada sugerencia.
import React from "react";
import useTitle from "../../hooks/useTitle";
import SaludPrecios from "../quotations/SaludPrecios";

const Precios = () => {
  useTitle("Precios");
  return (
    <div style={{ padding: "clamp(12px, 2.5vw, 18px) clamp(10px, 3vw, 22px)", background: "#1a1a1a", minHeight: "100%", color: "#ddd", boxSizing: "border-box" }}>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#fff" }}>💰 Precios: salud y sugerencia</div>
        <div style={{ fontSize: 12, color: "#8a8a8a", marginTop: 4, maxWidth: 820 }}>
          Cada pieza con su precio vigente, desde cuándo no cambia y cuánto subió la UF desde entonces. El precio
          sugerido mantiene el valor real de la venta; la explicación está escrita para decírsela al cliente tal cual.
          Para cambiar un precio, haz clic en la etiqueta de meses y ajústalo en el catálogo.
        </div>
      </div>
      <SaludPrecios abierto />
    </div>
  );
};

export default Precios;
